import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faBook, faCode, faPerson } from "@fortawesome/free-solid-svg-icons";

import InfoRow from "./InfoRow"
import Button from "../../../shared/components/elements/Button";
import { COURSE_MESSAGES } from "../messages";
import type { CourseDetail } from "../types";

interface InfoRowProps {
    label: string;
    value: string | number;
    icon?: IconDefinition;
}



interface CourseInfoPanelProps {
    course: CourseDetail;
    isAuthenticated: boolean;
    authLoading: boolean;
    enrolling: boolean;
    enrollError: string;
    onEnroll: () => void;
}

// Sticky side panel: course numbers and the enroll button
const CourseInfoPanel = ({
                             course,
                             isAuthenticated,
                             authLoading,
                             enrolling,
                             enrollError,
                             onEnroll
                         }: CourseInfoPanelProps) => {
    return (
        <div className="w-full lg:w-1/3 h-fit sticky top-32 rounded-lg bg-gray-100 mr-auto border-2 border-gray-200 p-2">
            <InfoRow label={COURSE_MESSAGES.users} value={course.users ?? "-"} icon={faPerson} />
            <InfoRow label={COURSE_MESSAGES.lessons} value={course.lessons ?? 0} icon={faBook} />
            <InfoRow label={COURSE_MESSAGES.projects} value={course.projects ?? 0} icon={faCode} />
            <InfoRow label={COURSE_MESSAGES.category} value={course.category || "-"} />

            {enrollError && (
                <p role="alert" className="text-red-500 text-center mx-2 mt-3">
                    {enrollError}
                </p>
            )}

            <Button
                className="w-full m-2"
                onClick={onEnroll}
                loading={enrolling}
                disabled={authLoading}
            >
                <span>
                    {isAuthenticated ? COURSE_MESSAGES.goToCourse : COURSE_MESSAGES.enroll}
                </span>
            </Button>
        </div>
    );
};

export default CourseInfoPanel;